module.exports = __webpack_public_path__ + "static/media/2025_VR_Travel.f699fe69.png";